import { useNavigate } from "react-router-dom";
import { useEffect} from "react";
import seriesStore from "../stores/seriesStore";
import episodeStore from "../stores/episodeStore";
import { filterByStatus } from "../utils/filterByStatus.js";
import statusStore from "../stores/statusStore.js";

export default function Calendar({ selectedShow, activeHeader, setActiveHeader }) {
   const navigate = useNavigate();

    const serStore = seriesStore();
    const epStore = episodeStore();
    const staStore = statusStore();

    const { filteredSeries: startedSeries, filteredSeasons: startedSeasons } =
          filterByStatus(staStore.status, serStore.series, "Started");
    const { filteredSeries: comingSoonSeries, filteredSeasons: comingSoonSeasons } =
          filterByStatus(staStore.status, serStore.series, "Finished what's available");

    const allSeriesIds = [
      ...startedSeries?.map((s) => s._id) || [],
      ...comingSoonSeries?.map((s) => s._id) || [],
    ];

    useEffect(() => {
      console.log("1");
     epStore.fetchEpisode(); 
    //  if (!epStore.episode?.length || selectedShow) {
    //     console.log("2");
         
    //   }
    }, [epStore.episode]);

    const today = new Date();
 
    const episodes =
      epStore.episode?.filter(
        (ep) =>
          allSeriesIds.includes(ep.seriesId) &&
          new Date(ep.releaseDate) >= today
      ).slice() // important: avoid mutating Zustand state
        .sort(
          (a, b) => new Date(a.releaseDate) - new Date(b.releaseDate)
        ) || [];

    const sortedEpisodes = [...episodes].sort((a, b) => {
      if (a.seriesId !== b.seriesId) return a.seriesId.localeCompare(b.seriesId);
      if (a.seasonNumber !== b.seasonNumber) return a.seasonNumber - b.seasonNumber;
      return a.episodeNumber - b.episodeNumber;
    });

    const combineEpisodes = (eps) => {
      const result = [];
      let current = null;

      // Sort by series, season, episode
      eps.sort((a, b) => {
        if (a.seriesId !== b.seriesId) return (seriesTitleById[a.seriesId] || "").localeCompare(seriesTitleById[b.seriesId] || "");
        if (a.seasonNumber !== b.seasonNumber) return a.seasonNumber - b.seasonNumber;
        return a.episodeNumber - b.episodeNumber;
      });

      eps.forEach(ep => { 
        if (
          current &&
          ep.seriesId === current.seriesId &&
          ep.seasonNumber === current.seasonNumber &&
          ep.episodeNumber === current.endEpisode + 1
        ) {
          current.endEpisode = ep.episodeNumber;
        } else {
          if (current) result.push(current);

          current = {
            ...ep,
            startEpisode: ep.episodeNumber,
            endEpisode: ep.episodeNumber
          };
        }
      });

      if (current) result.push(current);
      return result;
    }

    const formatDate = (date) =>
      new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        month: "short",
        day: "numeric",
    });

    const seriesTitleById = Object.fromEntries(
      serStore.series?.map((s) => [s._id, s.title]) || []
    );

    const seriesImgById = Object.fromEntries(
      serStore.series?.map((s) => [s._id, s.fanart]) || []
    );

    if (!epStore.episode) {
      return <p>Loading episodes…</p>;
    }

    today.setHours(0,0,0,0);

    const sevenDays = new Date();
    sevenDays.setDate(today.getDate() + 7);
    sevenDays.setHours(23,59,59,999);

    const { episodesThisWeek, episodesByMonth } = episodes.reduce((acc, ep) => {
      const release = new Date(ep.releaseDate);

      // Only future episodes
      if (release <= today) return acc;

      // Helper function to merge consecutive episodes
      const mergeInto = (arr, ep) => {
        const last = arr[arr.length - 1];
        if (
          last &&
          last.seriesId === ep.seriesId &&
          last.seasonNumber === ep.seasonNumber &&
          ep.episodeNumber === last.endEpisode + 1
        ) {
          last.endEpisode = ep.episodeNumber;
        } else {
          arr.push({
            ...ep,
            startEpisode: ep.episodeNumber,
            endEpisode: ep.episodeNumber
          });
        }
      };

      // Episodes within next 7 days
      if (release <= sevenDays) {
        mergeInto(acc.episodesThisWeek, ep);
      } 
      // Episodes after this week
      else {
        const monthKey = `${release.getFullYear()}-${String(release.getMonth() + 1).padStart(1, "0")}`;
        if (!acc.episodesByMonth[monthKey]) acc.episodesByMonth[monthKey] = [];
        mergeInto(acc.episodesByMonth[monthKey], ep);
      }

      return acc;
    },
    {
      episodesThisWeek: [],
      episodesByMonth: {}
    }
    );

     return (
      <div class="calendarDiv">
        <h2 className="calendarHeader">{activeHeader}</h2>
        {episodes.length === 0 ? (
          <p className="seriesListNoEpsMessage">Add currently airing shows to see their upcoming episodes.</p>
        ) : (
          <div>
            {/* This week */}
            <h4 className="episodeDayHeader">This Week</h4>

            {/* SAME CODE AS BELOW. ANY UPDATE MUST CHANGE IN BOTH PLACES */}
            {episodesThisWeek.map((ep) => (
                <div key={ep._id} className="calendarEpisodeItem" style={{
                    backgroundImage: `url('${seriesImgById[ep.seriesId]}')`,
                }}>
                <div className="calendarEpisodeContent">
                  <div className="calendarTopRow">
                    <p className="calendarTitle">
                      {seriesTitleById[ep.seriesId]}
                    </p>

                    <p className="calendarDay">
                      {new Date(ep.releaseDate).toLocaleDateString("en-US", {
                        weekday: "short"
                      })}
                    </p>
                  </div>

                  <div className="calendarBottomRow">
                    <p>
                    S{ep.seasonNumber}, 
                    {ep.startEpisode === ep.endEpisode
                          ? ` Ep${ep.startEpisode}`
                          : ` Ep${ep.startEpisode}-${ep.endEpisode}`}
                  </p>
                  </div>
                </div>
              </div>
            ))}
      

            {/* After this week */}
            {Object.entries(episodesByMonth).map(([day, eps]) => {          
              return (
              <div key={day}>
                <h4 className="episodeDayHeader">
                  {new Date(day).toLocaleDateString("en-US", { month: "long" })}
                </h4>

                {eps.map((ep) => (
                  <div key={`${ep.seriesId}-${ep.startEpisode}`} className="calendarEpisodeItem" style={{
                      backgroundImage: `url('${seriesImgById[ep.seriesId]}')`,
                  }}>
                    <div className="calendarEpisodeContent">
                      <div className="calendarTopRow">
                        <span className="calendarTitle">
                          {seriesTitleById[ep.seriesId]}
                        </span>

                        <span className="calendarDay">
                          {new Date(ep.releaseDate).toLocaleDateString("en-US", {
                            weekday: "short",
                            month: "numeric",
                            day: "numeric"
                          })}
                        </span>
                      </div>

                      <div className="calendarBottomRow">
                        S{ep.seasonNumber}, 
                        {ep.startEpisode === ep.endEpisode
                          ? ` Ep${ep.startEpisode}`
                          : ` Ep${ep.startEpisode}-${ep.endEpisode}`}
                      </div>

                    </div>
                  </div>
                ))}
              </div>
              )
            })
          }</div>
        )}
      </div>
    );
}
